/**
 * 创建人：zll
 * 时间：2020-07-21
 * 描述：关联弹框多选组件 
 * 使用说明: 参考 sw-link-multi 配置应用说明文档
 * 更新记录: 
 * 
 */
import { Component, OnInit, Input, forwardRef, ElementRef, Injector, ApplicationRef, ComponentFactoryResolver, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwLinkMultiComponent),
  multi: true
};

/**
 * 下拉多选框组件 sw-link-multi
 */
@Component({
  selector: 'sw-link-multi',
  templateUrl: './sw-link-multi.component.html',
  styleUrls: ['./sw-link-multi.component.css'],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class SwLinkMultiComponent implements ControlValueAccessor,OnInit {

  /**
   * 是否显示清除按钮
   */
  @Input() clearData: boolean = true;   

  /**
   * 下拉树组  [{id:"",text:""}]
   */
  @Input() datas: any[] = []; 
  
  /**
   * 是否禁止输入
   */
  @Input() disabled:Boolean = false

  /**
   * 未选择时提示语
   */
  @Input() placeholder: string = '';

  /**
   * 选中数据
   */
  @Output() changeClick = new EventEmitter();

  /**
   * 输出属性,清空后,将将清空值传递给父组件
   */
  @Output() clearClick = new EventEmitter();
   /**
   * 输出属性,选中要链接的对象，抛出
   */
  @Output() linkClick = new EventEmitter();
 
  /**
   * 输入框
   * @ignore
   */
  @ViewChild('input') input:ElementRef;

  /**
   * 显示文本值
   * @ignore
   */
  Text: string;   

  /**
   * 绑定值
   * @ignore
   */
  _id: string;  

  /**
   * @ignore
   */
  get Id(){
    return this._id;
  }

  /**
   * @ignore
   */
  set Id(value){
    this._id = value;
    this.propagateChange(this._id);
  }

  /**
   * @ignore
   */
  propagateChange = (_: any) => {};

  /**
   * 赋值参数
   * @ignore 
   */
  writeValue(value: string): void {
    if(value){
      // 如果有双向绑定的回显的数据
      //这里分割字符串的方法是以逗号 进行分割的,先把回显的id的字符串转化为数组
      this.selectedIds = value.split(",");
      //this.selectedIds 需要重新排序变成 this.selected，不然 this.selected 可能与 this.selectedText 顺序不一样， 导致点击input中右上角的删除时出错
      setTimeout(()=>{
        if(this.datas){
          this.selected = this.datas.filter(x => this.isChecked(x.id)).map(x => x.id);
          this.selectedText = this.datas.filter(x => this.isChecked(x.id)).map(x => x.text);
          this.Id = value;
          this.Text = this.selectedText.join(",")
        }
      },100)
      
    }else{
      // 如果有双向绑定的回显的数据为空
      // 选中id为空
      this._id = "";
      // 选中Text为空
      this.Text = "";
      // 选中项数组为空
      this.selected = [];
      // 选中项文字数组为空
      this.selectedText = []; 
    }
    
    let timer1 = setTimeout(() => {
      // 在定时器中重新设置组件的高度
      if(this.el.nativeElement.querySelector(".sw-select-multi-cont") && this.el.nativeElement.querySelector(".inputbox")){
          let height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
          let height2 = this.el.nativeElement.querySelector(".inputbox").offsetHeight
          if(height1 > height2){
            this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
            this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
          }
       
      
      }
      clearTimeout(timer1)
    }, 200);
  }

  /**
   * @ignore
   */
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  /**
   * @ignore
   */
  registerOnTouched(fn: any): void {
  }

  /**
   * @ignore
   */
  setDisabledState?(isDisabled: boolean): void {
  }

  /**
   * 定位width 
   * @ignore
   */
  width:string

  /**
   * 定位left
   * @ignore
   */
  left:string

  /**
   * 定位top
   * @ignore
   */
  top:string

  /**
   * 唯一主键
   * @ignore
   */
  ids:string

  /**
   * @ignore
   */
  constructor(
    private dic: DictionaryService,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private el :ElementRef,
    private box:SwMassageBoxService) { }

  /**
   * @ignore
   */
  ngOnChanges() {
    //放置先获取到选择数据
    //后获取到数据集的问题 
    //判断数据集合 选择数据都不为空的情况下选中数据
    if (this.datas && this.datas.length>0) {
      this.selectedText = this.datas.filter(x => this.isChecked(x.id)).map(x => x.text);
    }
  }

  /**
   * @ignore
   */
  ngOnInit() {
    this.ids = "select" + Math.random().toString().split(".")[1];
  }
 

  /**
   * 父组件要回显的id, 需要重新排序才能成为 组件选中的id : selected
   * @ignore
   */
  selectedIds = [];  

  /**
   * 选中的id
   * @ignore
   */
  selected = [];  

  /**
   * 选中的文本和id
   * @ignore
   */
  selectedText = [];  

  /**
   * 判断点击的数据是新增还是删除 ，做出相对的处理
   * @param action  添加还是删除
   * @param item  选中的数据
   * @ignore
   */
  private updateSelected(action, item){
    //新增添加点击的数据
    if(action == 'add' && this.selected.findIndex(value => value == item.id) == -1){
      this.selected.push(item.id);
      this.selectedText.push(item.text);
    }
    //删除 就删除对应的数据
    if(action == "remove" && this.selected.findIndex(value => value == item.id) != -1){
      this.selectedText.splice(this.selected.findIndex(value => value == item.id), 1);
      this.selected.splice(this.selected.findIndex(value => value == item.id), 1);
    }
    //将选择的数据凭借起来
    if(this.selectedText.length != 0){
      this.Text = this.selectedText.join(',');
      this.Id = this.selected.join(',');
    }else{
      this.Text = "";
      this.Id = "";
    }

    this.changeClick.emit(this.selected);

    //记录上一次改变时组件的高度
    let preHeight = this.el.nativeElement.querySelector(".inputbox").offsetHeight
    //多选结果多了,超过一行,就将输入框变高
    let timer2 = setTimeout(() => {
      if(this.selectedText.length){
        let height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
        this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
        this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
      }
      if(!this.selectedText.length){  //减少的时候,如果最后没有选中项,要有最小的高度
        this.el.nativeElement.querySelector(".inputbox").style.height = preHeight + 'px'
        this.el.nativeElement.querySelector(".form-control").style.height = preHeight + 'px'
      }
      clearTimeout(timer2)
    }, 0);
  }

  /**
   * 判断是否选中数据
   * @param id  选中的id
   * @ignore
   */
  isChecked(id){
    return this.selectedIds.findIndex(value => value == id) >= 0;
  }

  /**
   * 每个选择数据的单个删除事件
   * @param text 删除的对象
   * @ignore
   */
  closetigger(event,text: string) {
    event.stopPropagation()
    for (let item of this.datas) {
      if (item.text === text)
        this.updateSelected('remove', item);
    }
  }
  /**
   * 点击选中的数据 抛出
   * @param i
   * @ignore
   */
  clickLink(i) {
    let param = {}
    let id = this.selected[i]
    let text = this.selectedText[i]
    param = {id:id,text:text}
    this.linkClick.emit(param)
  }
  /**
   * 清空事件
   * @ignore
   */
  clearselect(){
    // 清空选中项
    this.selected = [];
    // 清空选中文本
    this.selectedText = []; 
    this.Text = "";
    this.Id = "";
    // 抛出空数组
    this.clearClick.emit([])
    this.changeClick.emit(this.selected);
    //清空所有的选中项之后,将组件高度还原
    if(this.el.nativeElement.querySelector(".sw-select-multi-cont")){
      this.el.nativeElement.querySelector(".sw-select-multi-cont").style.height = '0px'
    }
    this.el.nativeElement.querySelector(".inputbox").style.height = '34px'
    this.el.nativeElement.querySelector(".form-control").style.height = '34px'
  }

}
